import script from "./ShortLinkTool.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortLinkTool.vue?vue&type=script&setup=true&lang=js"

import "./ShortLinkTool.vue?vue&type=style&index=0&id=4bd8970e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd8970e"]])

export default __exports__